<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property pl-1">
            <th class="col-12">
              Acomodos
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="row pl-2">
            <td class="col-md-12 pl-3">
              <BadgeTitle
                v-for="measurement in programmeasure"
                :key="measurement.id"
                :title="parseArrangementName(measurement)"
                :has-icon="true"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { BadgeTitle } from '@/components/pei/shared';

const ENLARGED_FONT = 437;

export default {
  name: 'MeasurementProgramStudent',
  components: {
    BadgeTitle,
  },
  props: {
    programmeasure: {
      type: Array,
      required: true,
    },
    isAddedMode: {
      type: Boolean,
      default: () => false,
    },
  },
  methods:{
    parseArrangementName(item)
    {    
      let nameParsed = item.name;

      if(item.id == ENLARGED_FONT)
      {      
        nameParsed = `${item.name}-${item.enlargedFontSize}`;
      }     

      return nameParsed;      
    },
  }
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
</style>
